const templatePath = '/wp-content/themes/samenklimaatactief';
const form = <HTMLFormElement>document.getElementById('offerte-form');

/**
 * Post the form data to mailer script
 * @param  {string} url
 * @param  {any} data
 */
async function postData(url: string, data: any) {
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    body: data,
  });
  return response;
}

/**
 * Check the input fields for validity
 * @param  {NodeListOf<HTMLInputElement>} fields Input fields
 * @param  {boolean} single=false Check single field
 * @param  {HTMLInputElement} singleField=null The single field
 * @returns boolean all fields valid
 */
function checkFields(
  fields: NodeListOf<HTMLInputElement>,
  single: boolean = false,
  singleField = null,
): boolean {
  // If check single field
  // Aaply styling to it
  if (single) {
    const isValid = singleField.checkValidity();
    if (!isValid) {
      singleField.classList.add('error');
    } else {
      singleField.classList.remove('error');
    }
  }

  // Store if all fields are valid
  let allValid = false;

  // Create array to store validity
  const validArray = [];

  // Loop over all fields and check validity
  fields.forEach((field) => {
    const isValid = field.checkValidity();
    // Push validity to the array
    validArray.push(isValid);
  });

  // If the array does not includes any false
  // Set allValid to true
  if (!validArray.includes(false)) {
    allValid = true;
  }

  // Return if all fields are valid
  return allValid;
}

function initForm() {
  // Get the send button
  const sendButton = form.querySelector('.offerte__inputWrapper--send .button');

  // Get feedback field
  const feedbackField = <HTMLSpanElement>form.querySelector('#offerte-form-feedback');

  // Get the checkbox elements
  const partnerCheckboxes = <NodeListOf<HTMLInputElement>>form.querySelectorAll('.partnerCheckbox');
  partnerCheckboxes.forEach((checkbox: any) => {
    // Get checkbox id
    const chekboxID = checkbox.getAttribute('id');

    // Find related input field and adresses
    const relatedInput = <HTMLInputElement>document.getElementById(`${chekboxID}--mail`);
    const mailAdresses = relatedInput.dataset.adresses;

    // Add click listener to toggle input value
    checkbox.addEventListener('click', () => {
      if (checkbox.checked) {
        relatedInput.value = mailAdresses;
      } else {
        relatedInput.value = '';
      }
    });

    if (checkbox.parentElement.classList.contains('offerte__inputWrapper--hidden')) {
      relatedInput.value = mailAdresses;
    }
  });

  // Get financial partner checkbox
  const financialPartnerCheckbox = <HTMLInputElement>(
    document.getElementById('add-financial-partners')
  );
  const financialPartnerInput = <HTMLInputElement>(
    document.getElementById('add-financial-partners--checkbox--mail')
  );
  financialPartnerCheckbox.addEventListener('click', () => {
    if (financialPartnerCheckbox.checked) {
      financialPartnerInput.value = financialPartnerInput.dataset.adresses;
    } else {
      financialPartnerInput.value = '';
    }
  });

  // Get all required fields
  const requiredFields = <NodeListOf<HTMLInputElement>>(
    form.querySelectorAll('div[data-required] input')
  );
  requiredFields.forEach((field: HTMLInputElement) => {
    field.addEventListener('keydown', () => {
      if (!checkFields(requiredFields, true, field)) {
        sendButton.setAttribute('disabled', '');
      } else {
        sendButton.removeAttribute('disabled');
      }
    });
  });

  // Add send event
  sendButton.addEventListener('click', (event) => {
    event.preventDefault();

    // Check all valid fields before sending
    let isError: boolean = !checkFields(requiredFields);
    let errorMessage: string = 'Vul alle verplichte velden in';

    let oneChecked = false;

    // Check all checkboxes for input
    partnerCheckboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        oneChecked = true;
      }
    });

    if (!oneChecked) {
      isError = true;
      errorMessage = 'Kies waarvoor de aanvraag is.';
    }

    // Throw error message
    if (isError) {
      feedbackField.innerText = errorMessage;
      return;
    }

    // @ts-ignore Get the form data
    const formData = new FormData(form);
    // @ts-ignore
    global.formData = formData;

    // Add files to upload
    const fileUpload = <HTMLInputElement>document.getElementById('file_upload');
    const file = fileUpload.files;
    formData.append('files[]', file[0]);

    // Send form
    postData(`${templatePath}/templates/components/form-offerte-mailer.php`, formData).then(
      (response) => {
        response.text().then((text) => {
          // Add the response to the form
          feedbackField.innerText = text;

          // Get all inputs and textareas
          const formInputs = <NodeListOf<HTMLInputElement>>(
            form.querySelectorAll('.offerte__inputWrapper input')
          );
          const formAreas = <NodeListOf<HTMLTextAreaElement>>form.querySelectorAll('textarea');

          // Empty all input fields
          formInputs.forEach((input) => {
            input.value = '';
          });

          // Empty all textareas
          formAreas.forEach((area) => {
            area.value = '';
          });
        });
      },
    );
  });
}

// If a form exists
// Initalize the form sender and validator
if (form) {
  initForm();
}
